import { createSlice } from '@reduxjs/toolkit';
import { PplPlacesStateType } from 'src/types/pplPlaces';
import { formatData } from './functions';

const initialState: PplPlacesStateType = {
    loading: false,
    data: undefined,
    error: false,
    selectedCountry: null,
};
export const pplPlacesSlice = createSlice({
    name: 'pplPlaces',
    initialState,
    reducers: {
        getPplPlacesFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getPplPlacesFetchSuccess: (state, action) => {
            state.data = formatData(action.payload);
            state.loading = false;
        },
        getPplPlacesFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        getPplPlaceByAddressIdFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getPplPlaceByAddressIdFetchSuccess: (state, action) => {
            state.selectedCountry = action.payload.country;
            state.loading = false;
        },
        getPplPlaceByAddressIdFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        clearSelectedCountry: (state) => {
            state.selectedCountry = null;
        },
    },
});

export const {
    getPplPlacesFetch,
    getPplPlacesFetchSuccess,
    getPplPlacesFetchFailure,
    getPplPlaceByAddressIdFetch,
    getPplPlaceByAddressIdFetchSuccess,
    getPplPlaceByAddressIdFetchFailure,
    clearSelectedCountry,
} = pplPlacesSlice.actions;

export default pplPlacesSlice.reducer;
